// パスワード忘れ : パスワード再設定処理 /passwordChange
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import ToggleDisplay from 'react-toggle-display';
import Header from './header';
import Footer from './footer';
import './css/passwordReset.css';
import { changePassword } from "./firebase";
import users from './store/user';

export default class passwordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordAgain: '',
      currentPassword: '',
      isInvalidPass: false,
      errorMessage: '',
    }
  }
  
  handleChangeCurrentPassword = (e) => {
    this.setState({ currentPassword: e.target.value });
  }

  handleChangePassword = (e) => {
    this.setState({ password: e.target.value });
  }

  handleChangePasswordAgain = (e) => {
    this.setState({ passwordAgain: e.target.value });
  }

  setPassword = async (e) => {
    // form validations
    if (0 === this.state.currentPassword.length) {
      this.setState({ errorMessage: '※旧パスワードを入力してください' });
      this.setState({ isInvalidPass: true });
      return
    } else if (0 === this.state.password.length) {
      this.setState({ errorMessage: '※パスワードを入力してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (0 === this.state.passwordAgain.length) {
      this.setState({ errorMessage: '※確認用パスワードを入力してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (this.state.password !== this.state.passwordAgain) {
      this.setState({ errorMessage: '※パスワードが一致しません。再度入力してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (!this.state.password.match(/[A-Z]/)) {
      // 大文字
      this.setState({ errorMessage: '※最低１文字の英大文字を設定してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (!this.state.password.match(/[a-z]/)) {
      // 小文字
      this.setState({ errorMessage: '※最低１文字の英小文字を設定してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (!this.state.password.match(/\d/)) {
      // 数字
      this.setState({ errorMessage: '※最低１文字の数字を設定してください' });
      this.setState({ isInvalidPass: true });
      return;
    }

    const currentPassword = this.state.currentPassword;
    const newPassword = this.state.password;

    changePassword(currentPassword, newPassword)
      .then(() => {
        browserHistory.push("/user/" + users.getMyUser().uid);
      })
      .catch(err => {
        if ('auth/weak-password' === err.code) {
          this.setState({ errorMessage: '※最低６文字で設定してください'} );
          this.setState({ isInvalidPass: true });
          return;
        } else if ('wrong-password' === err.code) {
          this.setState({ errorMessage: '※正しいパスワードを入力してください'} );
          this.setState({ isInvalidPass: true });
          return;
        }
        console.log(err)
      })
  }

  render () {
    return (
      <div id="wrapper">
        <div id="" className="wrapper-lp wrapper-passwordReset1">
        <Header parentProps={this.props} />
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
                <div className="content-top">
                  <div className="block-passwordReset1">
                    <h2 className="title">パスワード設定</h2>
                    <p className="password-term">
                      パスワードは最低６文字、且つ１文字以上の大文字・小文字・数字を含む必要があります。
                    </p>
                    <form className="form-password-reset">
                    <ToggleDisplay if={ this.state.isInvalidPass }>
                      <p>{this.state.errorMessage}</p>
                    </ToggleDisplay>
                      <input type="password" placeholder="旧パスワードを入力ください" onChange={e => this.handleChangeCurrentPassword(e)}></input>
                      <input type="password" placeholder="パスワードを入力ください" onChange={e => this.handleChangePassword(e)}></input>
                      <input type="password" placeholder="パスワードを再度入力ください" onChange={e => this.handleChangePasswordAgain(e)}></input>
                      <button className="submit" type="button" onClick={e => this.setPassword(e)}>設定する</button>
                    </form>
                  </div>
                </div>
              </div>
              <Footer/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/passwordChange.js